import { useEffect } from 'react';
import { trackEvent } from '../utils/analytics';

// Document-level click listener that fires `outbound_click` for any anchor
// whose hostname differs from the current page. Mounted once at App level.
//
// Anchors marked with `data-track="manual"` are skipped — use that when a
// component fires its own richer event (e.g. publication_click with a title).
export default function OutboundLinkListener() {
  useEffect(() => {
    const handleClick = (event) => {
      // Walk up the DOM to find the nearest anchor (handles clicks on inner
      // <img>, <span>, etc.).
      let el = event.target;
      while (el && el !== document.body) {
        if (el.tagName === 'A') break;
        el = el.parentElement;
      }
      if (!el || el.tagName !== 'A') return;

      if (el.dataset && el.dataset.track === 'manual') return;

      const href = el.getAttribute('href');
      if (!href) return;

      let url;
      try {
        url = new URL(href, window.location.href);
      } catch {
        return;
      }

      if (url.hostname === window.location.hostname) return;
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return;

      const linkText = (el.textContent || '').trim().slice(0, 100);
      trackEvent('outbound_click', {
        link_url: url.href,
        link_hostname: url.hostname,
        link_text: linkText,
        page_path: window.location.pathname + window.location.search,
      });
    };

    // Capture phase so we fire before any navigation handler.
    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, []);

  return null;
}
